module.exports = __webpack_public_path__ + "media/8.fb2581d5.mp3";